
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Download, Upload, RotateCcw } from "lucide-react";

interface SystemSettingsProps {
  settings: any;
  onSettingsChange: (settings: any) => void;
}

const SystemSettings = ({ settings, onSettingsChange }: SystemSettingsProps) => {
  const handleExportData = () => {
    // Implement data export functionality
    // Export data functionality
  };

  const handleImportData = () => {
    // Implement data import functionality
    // Import data functionality
  };

  return (
    <div className="space-y-6">
      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-card-foreground">Backup & Maintenance</CardTitle>
          <CardDescription className="text-admin-muted-foreground">
            Manage your data and system maintenance
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-admin-card-foreground">Auto Backup</Label>
              <p className="text-xs text-admin-muted-foreground">
                Automatically backup your data daily
              </p>
            </div>
            <Switch
              checked={settings.autoBackup || false}
              onCheckedChange={(checked) => onSettingsChange({ autoBackup: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-admin-card-foreground">Maintenance Mode</Label>
              <p className="text-xs text-admin-muted-foreground">
                Put the site in maintenance mode for updates
              </p>
            </div>
            <Switch
              checked={settings.maintenanceMode || false}
              onCheckedChange={(checked) => onSettingsChange({ maintenanceMode: checked })}
            />
          </div>
        </CardContent>
      </Card>

      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-card-foreground">Data Management</CardTitle>
          <CardDescription className="text-admin-muted-foreground">
            Export, import, and manage your data
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex space-x-3">
            <Button
              variant="outline"
              onClick={handleExportData}
              className="border-admin-border hover:bg-admin-accent"
            >
              <Download className="h-4 w-4 mr-2" />
              Export Data
            </Button>
            <Button
              variant="outline"
              onClick={handleImportData}
              className="border-admin-border hover:bg-admin-accent"
            >
              <Upload className="h-4 w-4 mr-2" />
              Import Data
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SystemSettings;
